import React, { useState, lazy, Suspense } from 'react';
import { Button } from '@/components/ui/button';
import { Shield, Search, HeartHandshake } from 'lucide-react';
import aboutImage from '@/assets/despre-solyra-section.webp';

const OfferRequestForm = lazy(() => import('@/components/OfferRequestForm'));

const content = {
  title: <>Nu recomandăm panouri tuturor.<br className="hidden md:block" />Și asta e un lucru bun.</>,
  subtitle: 'Analizăm fiecare casă individual. Dacă investiția nu are sens, îți spunem sincer — înainte să cheltuiești vreun ban.',
  features: [
    {
      icon: Search,
      title: 'Analiză sinceră',
      description: 'Evaluăm locația, acoperișul și consumul tău. Dacă panourile nu merită, îți spunem direct.',
    },
    {
      icon: Shield,
      title: 'Instalatori verificați ANRE',
      description: 'Lucrăm doar cu instalatori autorizați, cu experiență dovedită și recenzii reale.',
    },
    {
      icon: HeartHandshake,
      title: 'Gestionăm totul cap-coadă',
      description: 'De la analiză la instalare și punere în funcțiune — tu nu trebuie să te ocupi de nimic.',
    },
  ],
};

const AboutSolyraSection: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <section className="py-20 md:py-28">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-12 mb-16 md:mb-20 items-start">
          <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold leading-tight">
            {content.title}
          </h2>
          <p className="text-muted-foreground text-lg leading-relaxed md:pt-2">
            {content.subtitle}
          </p>
        </div>

        {/* Features + image */}
        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 md:order-1">
            <img
              src={aboutImage}
              alt="Echipă Solyra - instalare panouri fotovoltaice"
              width="800"
              height="533"
              className="w-full h-auto rounded-2xl"
              loading="lazy"
            />
          </div>
          <div className="order-1 md:order-2 space-y-8">
            {content.features.map((feature, i) => (
              <div key={i} className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center">
                  <feature.icon size={24} className="text-accent" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-1">{feature.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
                </div>
              </div>
            ))}
            <Button size="lg" onClick={() => setIsFormOpen(true)} className="mt-4 px-8">
              Verifică gratuit
            </Button>
          </div>
        </div>
      </div>

      {isFormOpen && (
        <Suspense fallback={null}>
          <OfferRequestForm open={isFormOpen} onOpenChange={setIsFormOpen} />
        </Suspense>
      )}
    </section>
  );
};

export default AboutSolyraSection;
